import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function ConsistencyTraceabilityStandards() {
  return <section id="consistency-traceability-standards" className="bg-[#0F1B2D] py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 font-default">
          How Does Evermark Keep OEM Marking Consistent and Traceable?
        </h2>
        
        <div className="space-y-6 text-lg text-[#E8E4DC] leading-relaxed">
          <p>
            Consistency is the core of an OEM program: identical material, layout, and placement on every unit, with serialization that supports traceability across production. Evermark Industrial Solutions marks sequential and variable serial numbers, 2D data matrix codes, and unique identifiers from a supplied sequence, so each unit is individually traceable.
          </p>
          <p>
            Where an OEM's product carries regulatory or customer marking requirements — such as UL/ETL component marking conventions, MIL-STD-130 item marking, or MIL-SPEC nameplate standards — Evermark Industrial Solutions produces marking designed to align with the specified standard when properly specified. Evermark produces the marking and does not certify the OEM's product or confer a listing; compliance with a standard, listing, or contract depends on the product, the requirement, and the governing authority, which Evermark recommends confirming with the OEM's engineering or quality team or a qualified specialist.
          </p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-6 sm:gap-10">
          
          
        </div>
      </div>
    </section>;
}